import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';



function SectionName({ title }) {
    useEffect(() => {
        AOS.init();
      }, []);

    return (
        <>
            <div className="section_head" data-aos="fade-right" data-aos-duration="3000" data-aos-easing="linear">
                <h2>{title}</h2>
            </div>
        </>
    )
}

export default SectionName